var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDownOutlined = function SvgDownOutlined(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 8,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.813 0H10.64a.25.25 0 0 0-.202.103L6 6.222 1.561.103A.25.25 0 0 0 1.36 0H.188C.086 0 .027.116.086.198l5.51 7.596c.2.275.609.275.807 0l5.51-7.596a.124.124 0 0 0-.1-.198Z"
  })));
};
export default SvgDownOutlined;